export const RESULT_SIZE = 40;
export const DEFAULT_SEARCH_DEBOUNCE_TIME = 300;
export const DEFAULT_DESIGNER_FTP_FOLDER = 'Priprava';
export const CLIENT_ID = (Math.random() * 1e64).toString(16);
